<template>
  <svg viewBox="0 0 580 460">
    <text :x="decoration.position_x" :y="decoration.position_y" :style="styleObject" text-anchor="middle">
      <slot></slot>
    </text>
  </svg>
</template>

<script>
  export default {
    name: 'decoration',
    props: ['decoration'],
    computed: {
      styleObject: function(){
        return {
          fill: (this.decoration.outline_color) ? this.decoration.outline_color.color : 'rgb(255,255,255)',
          stroke: (this.decoration.outline_color) ? this.decoration.outline_color.color : 'rgb(255,255,255)',
          strokeWidth: '30px',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          fontSize: this.decoration.font_size+'px',
          textTransform: 'capitalize'
        }
      }
    },
  }
</script>